<idp-unsupported-browser></idp-unsupported-browser>

<idp-alert-advisories-container
  *ngIf="showAlertAdvisories()"
  [displayCloseIcon]="headerState.displayCloseIcon()"
  [hamburgerMenuOpen]="headerState.hamburgerMenuOpen"
  data-acdl-page-section="header:alerts and advisories"
></idp-alert-advisories-container>

<idp-skip-navigation-wrapper
  [buttonLabel]="
    headerFooterContent()?.header?.skipContentButtonLabel ||
    'Skip to Main Content'
  "
></idp-skip-navigation-wrapper>

@defer (
  when (languageRedirectionFacade.flyOutConfirmationContent$ | async) !==
null
) {
  <idp-lang-select-confirmation
    [content]="(languageRedirectionFacade.flyOutConfirmationContent$ | async)!"
    [showModal]="languageRedirectionFacade.showLangSelectionModal"
    (flyoutLangConfirmed)="
      languageRedirectionFacade.setPrefCookieOnSelect($event)
    "
    (openCls)="languageRedirectionFacade.openCLS()"
    (closeEvent)="languageRedirectionFacade.close()"
  ></idp-lang-select-confirmation>
}
@defer (
  when (flyoutLangSelectorFacade.flyOutLanguageSelectorContent$ | async)
!== null
) {
  @if (flyoutLangSelectorFacade.showSelectorModal()) {
    <idp-lang-selector
      [content]="
        (flyoutLangSelectorFacade.flyOutLanguageSelectorContent$ | async)!
      "
      [showModal]="flyoutLangSelectorFacade.showSelectorModal()"
      [searchList]="flyoutLangSelectorFacade.searchList$ | async"
      (closeEvent)="flyoutLangSelectorFacade.updateShowModal()"
      (displayContentLanguageEvent)="
        flyoutLangSelectorFacade.setClsValues($event)
      "
      (searchValueChangeEvent)="
        flyoutLangSelectorFacade.onSearchValueChanged($event)
      "
      (afterLanguageSelectedEvent)="
        flyoutLangSelectorFacade.afterLanguageSelected($event)
      "
      (regionClicked)="flyoutLangSelectorFacade.onRegionClicked($event)"
    ></idp-lang-selector>
  }
}

<ng-container *ngIf="!headerState.isLightHeaderFooterEnable">
  <nav
    idpHeaderPosition
    [collapsedHeader]="collapsedHeader()"
    [selectedNavScroll]="headerState.navClickTimestamp()"
    [selectedNav]="headerState.selectedNav()"
    [selectedBookingTab]="headerState.selectedBookingTab()"
    [shouldShowMobileFullScreen]="headerState.shouldShowMobileFullScreen()"
    [modifyButtonClicked]="headerState.modifyButtonClick()"
    [shopHeader]="isSlimHeader()"
    idpInspirationSubNavContainer
    idpClickOutside
    [APP_DISABLE_LEGACY]="configuration.APP_DISABLE_LEGACY"
    [isMobile]="screenDetection.isMobile()"
    [selectedNav]="headerState.selectedNav()"
    [selectedBookingTab]="headerState.selectedBookingTab()"
    (appClickOutside)="primaryNavAction($event)"
    (appScrolledToTop)="
      !configuration.APP_DISABLE_LEGACY && headerState.selectedNav.set($event)
    "
    [ngClass]="{
      'header--business': isBusinessAccount,
      'dark-site-theme': darkSiteTheme === 'true'
    }"
    [attr.data-design-system]="
      darkSiteTheme === 'true' ? 'delta-mach-1-dark' : ''
    "
    [class]="
      'header header--container px-0 ' +
      (headerState.selectedNav() === headerState.navigationType.book &&
      headerState.selectedBookingTab() ===
        headerState.bookingCategoryType.flights &&
      darkSiteLevel !== 'level0' &&
      !isSlimHeader() &&
      !showFafHeader()
        ? 'min-h-[209px] tablet:min-h-[195px] laptop:min-h-[214px] '
        : '') +
      (isBusinessAccount
        ? 'bg-[#000]'
        : darkSiteTheme === 'true'
          ? 'bg-[linear-gradient(180deg,#4c4e52_0%,#3a3e42_100%)]'
          : 'bg-[linear-gradient(180deg,#001932_0%,#001122_100%)]')
    "
    id="mach-core-header-nav"
    idpTabOrderFocus
  >
    <div
      [ngClass]="{
        'z-10': headerState.hamburgerMenuOpen && !showFafHeader(),
        'z-[1030]': !headerState.displayCloseIcon() && !showFafHeader(),
        'z-[1040]': showFafHeader()
      }"
      [class]="
        'header__top top-0 left-0 right-0 flex justify-center items-center h-[52px] laptop:h-[auto] laptop:py-[16px] ' +
        (darkSiteLevel === 'level0' && !showFafHeader()
          ? 'py-0 tablet:py-[5px] laptop:!py-[5px] '
          : '') +
        (isBusinessAccount || darkSiteTheme === 'true'
          ? 'bg-[#000]'
          : 'bg-[linear-gradient(180deg,#001932_0%,#001122_100%)]')
      "
    >
      <div
        class="mach__container flex justify-center items-center w-full relative"
      >
        <div
          *ngIf="showFafHeader()"
          class="header__brand flex-shrink-0 ultrawide:flex-grow laptop:mr-24 desktop:mr-[28px] mr-[auto]"
        >
          <button
            class="flex items-center gap-[8px] text-inverse cursor-pointer"
            (click)="onFafBackNavigation()"
            (keydown.enter)="onFafBackNavigation()"
            data-acdl-action="header:back navigation"
            data-acdl-name="trip details"
            data-acdl-page-section="header:trip details"
            id="mach-core-faf-header-back"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M13.125 16.25L6.875 10L13.125 3.75"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="text-label-xs-semibold text-inverse whitespace-nowrap">
              {{ fafBackLinkLabel() }}
            </span>
          </button>
        </div>

        <!-- Delta Logo and Hamburger Icon start -->
        <div
          [ngClass]="{
            'ultrawide:flex-grow laptop:mr-24 desktop:mr-[28px]':
              !isSlimHeader() && !showFafHeader(),
            'mr-[auto]':
              (!headerState.showLogo || darkSiteLevel !== 'level0') &&
              !this.shopHeader() &&
              !showFafHeader() &&
              !navSlimService.updateVacationData(),
            'w-full tablet:w-full laptop:w-[80%] flex justify-between !m-0 items-center':
              darkSiteLevel === 'level0' && !showFafHeader(),
            'absolute left-1/2 -translate-x-1/2 hidden laptop:block':
              showFafHeader(),
            'mr-0': navSlimService.updateVacationData()
          }"
          class="header__brand flex-shrink-0"
        >
          <idp-header-logo
            *ngIf="
              showFafHeader() ||
              vacationFlowInput().enableHeader ||
              headerState.showLogo ||
              darkSiteLevel === 'level0'
            "
            [isBusiness]="isBusinessAccount"
            [vacationHeader]="vacationFlowInput().enableHeader"
          ></idp-header-logo>
          <div
            tabIndex="0"
            *ngIf="
              !showFafHeader() &&
              !vacationFlowInput().enableHeader &&
              !headerState.showLogo &&
              !headerState.hamburgerMenuOpen &&
              !headerState.displayCloseIcon() &&
              darkSiteLevel !== 'level0'
            "
            [ngClass]="{
              'mr-[13.5px]': isSlimHeader()
            }"
            class="hamburger relative block w-6 h-6 text-icon-inverse"
            (click)="openMenu()"
            (keydown.enter)="openMenu()"
            id="mach-core-header-hamburger"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 19.25H22.5V17H1.5V19.25ZM1.5 14H22.5V11.75H1.5V14ZM1.5 6.5V8.75H22.5V6.5H1.5Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <idp-close-header-button
            *ngIf="
              !showFafHeader() &&
              (headerState.hamburgerMenuOpen ||
                headerState.displayCloseIcon()) &&
              !headerState.modifyButtonClick()
            "
            class="absolute right-[24px] bottom-[-13px]"
            (closeHeader)="closeIconClicked(true)"
          ></idp-close-header-button>
          <img
            *ngIf="!showFafHeader() && darkSiteLevel === 'level0'"
            class="w-[4.9375rem] h-12 laptop:h-[4.0625rem]"
            [src]="
              darkSiteTheme === 'true' ? darkSiteBlackThemeLogo : darkSiteLogo
            "
            alt="delta logo"
          />
        </div>
        <!-- Delta Logo and Hamburger Icon end -->

        <div
          *ngIf="showFafHeader()"
          class="hidden laptop:flex laptop:flex-grow"
        ></div>
        <!-- Delta Navigation links start -->
        <idp-navigation-links
          [ngClass]="{
            'laptop:w-[596px] ultrawide:w-[792px]': isLoggedIn(),
            'laptop:w-[535px] ultrawide:w-[739px]': !isLoggedIn()
          }"
          class="header__nav hidden tablet:mr-24 laptop:mr-0 laptop:flex !w-fit !mr-[20px] ultrawide:flex-grow"
          *ngIf="
            !showFafHeader() && !isSlimHeader() && darkSiteLevel !== 'level0'
          "
          [isMobile]="screenDetection.isMobile()"
          [selectedNav]="
            headerState.selectedNav() || headerState.previousPrimarySelectedNav
          "
          [selectedSecondaryNav]="headerState.secondaryNav"
          [isLoggedIn]="isLoggedIn()"
          [isBusinessAccount]="
            isLoggedIn() &&
            accountManagement.displayBusinessTypeSection &&
            !headerState.restrictProfileSelector
          "
          (primaryNavActionEvent)="primaryNavAction($event)"
          (secondaryNavActionEvent)="secondaryNavAction($event)"
        ></idp-navigation-links>
        <!-- Delta Navigation Normal Booking End-->

        <!-- Delta Navigation Shopping Booking Start-->
        <div
          [ngClass]="{
            hidden: headerState.displayCloseIcon() && clickFromMobileNavButton
          }"
          class="header__shop mr-[auto] laptop:mr-0 ultrawide:mr-[auto]"
          *ngIf="isSlimHeader()"
        >
          <idp-header-slim
            *ngIf="!headerState.hamburgerMenuOpen"
            [shopHeader]="shopHeader()"
            [vacationFlowInput]="vacationFlowInput()"
            (modifyButtonClicked)="headerState.setModifyButtonClick($event)"
            (vacationFlowOutput)="vacationFlowOutput.emit($event)"
          ></idp-header-slim>
        </div>
        <!-- Delta Navigation Shopping Booking End-->

        <!-- Delta Login start -->
        <idp-login-wrapper
          [ngClass]="{
            'mt-[5.5px] mr-[16px]': !isSlimHeader(),
            'mr-[8px] ml-[25px]':
              isSlimHeader() && !isLoggedIn() && !headerState.isMultiCityTrip(),
            'mr-[6px]': isLoggedIn(),
            'ml-0':
              isSlimHeader() && !isLoggedIn() && headerState.isMultiCityTrip()
          }"
          class="header__login laptop:mt-[0px] laptop:pb-[6px] ml-[16px]"
          [shopHeader]="isSlimHeader()"
          [isAlertAdvisory]="headerState.alertBanner()"
          (triggerLogin)="openLoginModal()"
          *ngIf="
            !headerState.hamburgerMenuOpen &&
            !headerState.displayCloseIcon() &&
            darkSiteLevel !== 'level0'
          "
        ></idp-login-wrapper>
        <!-- Delta Login end -->

        <idp-notification
          class="header__notification mt-[5.5px] laptop:mt-[0px]"
          *ngIf="
            !headerState.hamburgerMenuOpen &&
            !headerState.displayCloseIcon() &&
            darkSiteLevel !== 'level0'
          "
          [isAlertAdvisory]="headerState.alertBanner()"
        ></idp-notification>

        <!-- Profile Selector start -->
        <ng-container
          *ngIf="
            !showFafHeader() &&
            isLoggedIn() &&
            accountManagement.displayBusinessTypeSection &&
            !headerState.restrictProfileSelector
          "
        >
          <div
            *ngIf="
              !headerState.hamburgerMenuOpen && !headerState.displayCloseIcon()
            "
            [ngClass]="{
              hidden: isSlimHeader()
            }"
            class="header__divider w-[1px] h-[36px] mx-8 border-[1px] text-neutral-1000 tablet:block"
          ></div>

          <idp-switch-profile
            (flyoutToggleChange)="headerState.switchAccountToggle = $event"
            *ngIf="
              !headerState.hamburgerMenuOpen &&
              !headerState.displayCloseIcon() &&
              darkSiteLevel !== 'level0'
            "
            [flyoutToggle]="headerState.switchAccountToggle"
          ></idp-switch-profile>

          <idp-profile-selector
            *ngIf="headerState.switchAccountToggle"
            (closeFlyout)="headerState.switchAccountToggle = $event"
            (showSwitching)="headerState.showInterstitialScreen.set($event)"
            [enableMachCoreProfileSelector]="true"
            [isAlertAdvisory]="headerState.alertBanner()"
          ></idp-profile-selector>

          @defer (when headerState.showInterstitialScreen()) {
            <idp-interstitial></idp-interstitial>
          }
        </ng-container>
        <!-- Profile Selector end -->

        <div
          *ngIf="
            !headerState.hamburgerMenuOpen &&
            !headerState.displayCloseIcon() &&
            darkSiteLevel !== 'level0'
          "
          [ngClass]="{
            'tablet:block':
              !showFafHeader() &&
              !vacationFlowInput().enableHeader &&
              !shouldHideSearchIcon() &&
              !headerState.displayCloseIcon() &&
              !visibilityHidden,
            '!hidden':
              (headerState.displayCloseIcon() || shouldHideSearchIcon()) &&
              !visibilityHidden,
            'hidden laptop:block laptop:invisible': visibilityHidden,
            'hidden laptop:block': showFafHeader(),
            'max-[992px]:hidden': vacationFlowInput().enableHeader
          }"
          class="header__divider w-[1px] h-[36px] mx-8 border-[1px] text-neutral-1000"
        ></div>
        <idp-search-wrapper
          *ngIf="!headerState.hamburgerMenuOpen && darkSiteLevel !== 'level0'"
          [ngClass]="{
            'tablet:block':
              !showFafHeader() &&
              !vacationFlowInput().enableHeader &&
              !shouldHideSearchIcon() &&
              !headerState.displayCloseIcon() &&
              !visibilityHidden,
            '!hidden':
              (headerState.displayCloseIcon() || shouldHideSearchIcon()) &&
              !visibilityHidden,
            'hidden laptop:block laptop:invisible': visibilityHidden,
            'hidden laptop:block': showFafHeader(),
            'max-[992px]:hidden': vacationFlowInput().enableHeader
          }"
          class="header__search mt-[5.5px] ml-[6px] laptop:mt-[0px]"
          [displaySearchFooter]="false"
          [isAlertAdvisory]="headerState.alertBanner()"
          [attr.aria-hidden]="shouldHideSearchIcon()"
        ></idp-search-wrapper>
        <!-- Delta Notification and Search end -->
      </div>
    </div>

    <!-- Mobile Widget Delta Navigation links start -->
    <div
      *ngIf="
        !showFafHeader() &&
        screenDetection.isMobile() &&
        darkSiteLevel !== 'level0'
      "
      [ngClass]="{
        'fixed top-[52px] left-0 right-0 z-[1030] overflow-y-auto':
          headerState.hamburgerMenuOpen,
        'z-[0]':
          !headerState.displayCloseIcon() && !headerState.hamburgerMenuOpen,
        hidden:
          !clickFromMobileNavButton &&
          !headerState.hamburgerMenuOpen &&
          isSlimHeader()
      }"
      [class]="
        'widgets-container__nav-links relative flex justify-center ' +
        (isBusinessAccount || darkSiteTheme === 'true'
          ? 'bg-[#000]'
          : 'bg-surface-navigation')
      "
    >
      <idp-widget-navigation-links
        [selectedNav]="headerState.selectedNav()"
        [isMenuOpen]="headerState.hamburgerMenuOpen"
        [isMobile]="screenDetection.isMobile()"
        [isAlertAdvisory]="headerState.alertBanner()"
        [isBusiness]="accountManagement.isBusiness"
        [collapsedHeader]="collapsedHeader()"
        [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
        (widgetNavActionEvent)="primaryNavAction($event, true)"
      ></idp-widget-navigation-links>
    </div>
    <!-- Mobile Widget Delta Navigation links end -->

    <div
      *ngIf="
        !showFafHeader() &&
        headerState.selectedNav() === headerState.navigationType.book &&
        (!isSlimHeader() || clickFromMobileNavButton) &&
        !headerState.hamburgerMenuOpen &&
        darkSiteLevel !== 'level0'
      "
      [class]="
        'header__booking w-[100%] justify-center items-center overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] mobile:flex tablet:max-w-none tablet:justify-center ' +
        (isBusinessAccount || darkSiteTheme === 'true'
          ? 'bg-[#000]'
          : 'bg-surface-navigation')
      "
    >
      <idp-booking-tab
        (tabSelectEmit)="setBookingTabValue($event)"
        [selectedIndex]="headerState.bookingCategoryIndex"
      ></idp-booking-tab>
    </div>

    <div
      *ngIf="!showFafHeader()"
      [ngClass]="{
        'laptop:p-[24px]':
          headerState.isNotSecondaryNav() &&
          !(isSlimHeader() && !headerState.modifyButtonClick()),
        'tablet:p-16':
          headerState.isNotSecondaryNav() ||
          (headerState.modifyButtonClick() && isSlimHeader()),
        'ultrawide:pb-[32px] shadow-03':
          headerState.modifyButtonClick() && isSlimHeader(),
        'shadow-03': collapsedHeader(),
        'bg-surface-02':
          headerState.isNotSecondaryNav() && !headerState.isTripRelatedNav(),
        'bg-surface-01 laptop:bg-surface-02': headerState.isTripRelatedNav(),
        'laptop:p-[0px]': isSlimHeader() && !headerState.modifyButtonClick(),
        'fixed h-screen z-[1000] flex-col justify-start overflow-y-auto overflow-x-hidden tablet:h-screen tablet:z-[1000] tablet:flex-col tablet:justify-start':
          headerState.shouldShowMobileFullScreen(),
        'justify-center': !headerState.shouldShowMobileFullScreen(),
        hidden:
          headerState.hamburgerMenuOpen ||
          (headerState.selectedNav() === '' &&
            !headerState.displayCloseIcon()) ||
          darkSiteLevel === 'level0',
        '!bg-[#000]': darkSiteTheme === 'true'
      }"
      class="header__widgets flex items-center rounded-b-[8px]"
      (mouseleave)="mouseout()"
      id="mach-core-header-widgets"
    >
      <ng-container
        *ngIf="
          headerState.selectedNav() &&
          (!isSlimHeader() || clickFromMobileNavButton)
        "
        [ngSwitch]="headerState.selectedNav()"
      >
        @defer (
          when headerState.selectedNav() ===
        headerState.navigationType.myTrips
        ) {
          <idp-capability-my-trips-container
            class="overflow-y-auto laptop:overflow-visible"
            [content]="headerFooterContent()?.header?.my_trips"
            [hidden]="
              headerState.selectedNav() !== headerState.navigationType.myTrips
            "
            [isSelected]="
              headerState.selectedNav() === headerState.navigationType.myTrips
            "
            [ngClass]="{
              'overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-150px)] laptop:max-h-[none]':
                !headerState.alertBanner() && headerState.displayCloseIcon()
            }"
          ></idp-capability-my-trips-container>
        }
        @defer (
          when headerState.selectedNav() ===
        headerState.navigationType.checkIn
        ) {
          <idp-check-in-container
            class="overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-150px)] laptop:max-h-[none]"
            [hidden]="
              headerState.selectedNav() !== headerState.navigationType.checkIn
            "
            [isSelected]="
              headerState.selectedNav() === headerState.navigationType.checkIn
            "
            [content]="headerFooterContent()?.header?.check_in"
          ></idp-check-in-container>
        }
        @defer (
          when headerState.selectedNav() ===
        headerState.navigationType.flightStatus
        ) {
          <idp-flight-status-container
            [hidden]="
              headerState.selectedNav() !==
              headerState.navigationType.flightStatus
            "
            [isSelected]="
              headerState.selectedNav() ===
              headerState.navigationType.flightStatus
            "
            class="overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-150px)] laptop:max-h-[none]"
          ></idp-flight-status-container>
        }

        <ng-container *ngSwitchCase="headerState.navigationType.secondary">
          <idp-secondary-navigation-links
            [ngClass]="{
              '!bg-[#000]': darkSiteTheme === 'true' || isBusinessAccount,
              'bg-surface-navigation': darkSiteTheme !== 'true'
            }"
            [navigationId]="headerState.secondaryNav"
            [isMobile]="screenDetection.isMobile()"
          ></idp-secondary-navigation-links>
        </ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </ng-container>

      <!-- Booking Tab Category Start -->
      <idp-capability-flight-shop
        *ngIf="
          (!isSlimHeader() || clickFromMobileNavButton) &&
            componentLoader.shouldLoadFlights() &&
            flightsWidgetFacade.flightsWidget$ | ngrxPush as flightsWidgetAEM
        "
        id="flights"
        [flightShopWidgetTemplates]="flightTemplate.HOME"
        [hidden]="
          headerState.selectedNav() !== headerState.navigationType.book ||
          headerState.selectedBookingTab() !==
            headerState.bookingCategoryType.flights
        "
        [bookWidgetAem]="flightsWidgetAEM"
        [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
        class="overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-200px)] laptop:max-h-[none]"
        (expandEmit)="mobileViewShowOptions()"
        data-acdl-page-section="header:search widget"
        data-acdl-action="widget:"
      ></idp-capability-flight-shop>

      @defer (
        when headerState.selectedNav() === headerState.navigationType.book
      && headerState.selectedBookingTab() ===
      headerState.bookingCategoryType.vacations
      ) {
        <idp-booking-vacation
          [hidden]="
            headerState.selectedNav() !== headerState.navigationType.book ||
            headerState.selectedBookingTab() !==
              headerState.bookingCategoryType.vacations
          "
          id="vacations"
          class="overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-200px)] laptop:max-h-[none]"
          (expandEmit)="mobileViewShowOptions()"
          [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
          [isSelected]="
            headerState.selectedNav() === headerState.navigationType.book &&
            headerState.selectedBookingTab() ===
              headerState.bookingCategoryType.vacations
          "
          data-acdl-page-section="header:book:vacations"
          data-acdl-action="widget:vacations search"
          data-acdl-name="vacations:search"
        ></idp-booking-vacation>
      }
      @defer (
        when headerState.selectedNav() ===
      headerState.navigationType.book && headerState.selectedBookingTab() ===
      headerState.bookingCategoryType.cars
      ) {
        <idp-booking-cars
          [hidden]="
            headerState.selectedNav() !== headerState.navigationType.book ||
            headerState.selectedBookingTab() !==
              headerState.bookingCategoryType.cars
          "
          id="cars"
          class="overflow-y-auto overflow-x-hidden laptop:overflow-visible max-[768px]:p-16 tablet:px-0 max-h-[calc(100dvh-200px)] laptop:max-h-[none]"
          (expandEmit)="mobileViewShowOptions()"
          [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
          [isSelected]="
            headerState.selectedNav() === headerState.navigationType.book &&
            headerState.selectedBookingTab() ===
              headerState.bookingCategoryType.cars
          "
          data-acdl-page-section="header:book:cars"
          data-acdl-action="widget:find cars"
          data-acdl-name="cars:find cars"
        ></idp-booking-cars>
      }
      @defer (
        when headerState.selectedNav() ===
      headerState.navigationType.book && headerState.selectedBookingTab() ===
      headerState.bookingCategoryType.stays
      ) {
        <idp-booking-stays
          [hidden]="
            headerState.selectedNav() !== headerState.navigationType.book ||
            headerState.selectedBookingTab() !==
              headerState.bookingCategoryType.stays
          "
          id="stays"
          class="overflow-y-auto overflow-x-hidden max-[768px]:p-16 laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-200px)] laptop:max-h-[none]"
          (expandEmit)="mobileViewShowOptions()"
          [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
          [isSelected]="
            headerState.selectedNav() === headerState.navigationType.book &&
            headerState.selectedBookingTab() ===
              headerState.bookingCategoryType.stays
          "
          data-acdl-page-section="header:book:stays"
          data-acdl-action="widget:find stays"
          data-acdl-name="stays:find stays"
        ></idp-booking-stays>
      }

      <!-- Booking Tab Category End -->

      <!-- Shop Header Slim Nav Start -->
      <ng-container
        *ngIf="
          headerState.modifyButtonClick() &&
          !vacationFlowInput().enableHeader &&
          (flightsWidgetFacade.flightsWidget$ | ngrxPush) as flightsWidgetAEM
        "
      >
        <idp-capability-flight-shop
          id="flight-shop-slim-nav"
          class="overflow-y-auto overflow-x-hidden laptop:overflow-visible tablet:px-0 max-h-[calc(100dvh-70px)] laptop:max-h-[none] max-[992px]:pt-[16px]"
          [flightShopWidgetTemplates]="flightTemplate.MODIFY"
          [bookWidgetAem]="flightsWidgetAEM"
          [viewSearchOptionExpanded]="headerState.viewSearchOptionExpanded()"
          (expandEmit)="mobileViewShowOptions()"
        ></idp-capability-flight-shop>
      </ng-container>
      <!--  Shop Header  Slim Nav End -->

      <!-- Vacation Header Slim Nav Start -->
      @if (
        headerState.modifyButtonClick() &&
        vacationFlowInput().enableHeader &&
        !shopHeader()
      ) {
        <ng-container *ngTemplateOutlet="vacationBookingWidget"></ng-container>
      }
      <!-- Vacation Header Slim Nav End -->
    </div>
  </nav>
</ng-container>

<ng-container *ngIf="headerState.isLightHeaderFooterEnable">
  <div
    class="header header--container fixed w-[100vw] top-0 z-[1040] bg-[linear-gradient(180deg,#001932_0%,#001122_100%)] h-[52px] tablet:h-[78px] px-0 flex justify-center items-center"
  >
    <idp-header-logo
      [isBusiness]="accountManagement.isBusiness"
    ></idp-header-logo>
  </div>
</ng-container>

@defer (when triggerLoginModal() && !configuration.enableMachCoreLoginModal()) {
  <idp-login-modal-wrapper
    [fromApp]="fromApp()"
    [centerPage]="centerPage()"
    [redirectUrl]="redirectUrl()"
    [machCore]="true"
    [triggerLoginModal]="triggerLoginModal()"
    (modalClosed)="resetLoginModalTrigger()"
  ></idp-login-modal-wrapper>
}

@defer (when triggerLoginModal() && configuration.enableMachCoreLoginModal()) {
  <idp-login
    [isOpen]="triggerLoginModal()"
    [fromApp]="fromApp()"
    [forceRedirectUrl]="redirectUrl()"
    [content]="headerFooterContent()?.header?.login || loginMockContent"
    (closeModal)="resetLoginModalTrigger()"
  ></idp-login>
}
